import Vue from 'vue';
import Storage from 'vue-web-storage';

Vue.use(Storage, {
  prefix: 'your_app_slug_',// default `app_`
  drivers: ['session','local'], // default 'local'
});
